import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Col } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";
import Collapse from '@mui/material/Collapse';


import ExpandDown from '../../../../styles/images/expand-down.png';
import ExpandUp from '../../../../styles/images/expand-up.png';
import ArrowLeft from '../../../../styles/images/arrow-left.png';
import Coin from '../../../../styles/images/coin.png';
import Location from '../../../../styles/images/location-icon-grey.png';
import Phone from '../../../../styles/images/phone-dark.png';
import { handleChangeDataCardShop } from '../../../../redux/actions/pages/main/card_shop';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';




const CardShop = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {id, title, short_desc, cash_back, logo, address_title, discounts_pay_method, address, telephone, glat, glng, expandable} = props.data.item;

    const { expandedId } = useSelector(state => state.card_shop);

    const { isOpen } = useSelector(state => state.bottom_sheet);

    const [collapsed, setCollapsed] = React.useState(false);

    const handleCollapsed = () => {
        if(expandable) {
            if( !isOpen) {
                setCollapsed((prev) => !prev);
                dispatch(handleChangeDataCardShop('expandedId', (!collapsed ? id : 0)));
            }
            else
                dispatch(handleChangeDataBottomSheet('isOpen', false));
        }
        else
            navigate(`../shop/${id}/${title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`);
    };

    useEffect(() => {
        if(expandedId !== id)
            setCollapsed(false);
        // eslint-disable-next-line
    }, [expandedId]);

    

    return (

            <Col xs={12} className="mb-4 px-0" style={{cursor: 'pointer'}}>
                <div className="div-store" onClick={handleCollapsed}>
                    <div className="d-flex justify-content-center">
                        <div className="d-flex align-items-center">
                            <LazyLoadImage className="img-store-list" src={logo} alt={title} />
                        </div>

                        <div className="info mx-3">
                            <h6 className="mb-0">{title}</h6>
                            <span className="overflow-txt"  >
                                {short_desc}
                            </span>

                            <span className="d-flex justify-content-start" style={{whiteSpace: "nowrap"}} >
                                <span className="pull-back-info px-2 py-1 d-flex justify-content-center" >
                                    <div className="d-flex align-items-center">
                                        <img src={Coin} alt="بازگشت وجه" />
                                    </div>
                                    <div className="d-flex align-items-end mx-1" >
                                        <span style={{fontSize: "15px"}} >%{cash_back}</span> 
                                    </div>
                                    <span className="text-center d-flex flex-column justify-content-between" style={{flex: "1 1"}}>
                                        <span className="font-size-10 height-8">برگشت</span>
                                        <span className="font-size-10">وجـــــــــــه</span>
                                    </span>
                                    {/*<img src={CashBack} alt="بازگشت وجه" />*/}
                                </span>
                                <div className="horizontal-divider mx-2 d-flex align-items-center" />
                                <span className="address-title d-flex align-items-center">
                                    <img src={Location} height={20} className="mr-1" alt="آدرس" />
                                    {address_title}
                                </span>
                            </span>

                        </div>

                        <div className="d-flex align-items-center">
                            <img src={expandable ? (collapsed ? ExpandUp : ExpandDown) : ArrowLeft} width={30}  alt="نمایش بیشتر" />
                        </div>
                    </div>


                    <Collapse in={collapsed} className="mt-2">
                        {
                            discounts_pay_method.split("!#!#").map((item, key) => {
                                return(
                                    <div className="d-flex small-txt mt-1" key={key}>
                                        <div className="d-flex align-items-center mr-1">
                                            <img src={Coin} width={15} alt="بازگشت وجه" />
                                        </div>
                                        {item}
                                    </div>
                                );
                            })
                        }
                        <div className="d-flex small-txt mt-1">
                            <div className="d-flex align-items-center mr-1">
                                <img src={Location} width={15} alt="آدرس" />
                            </div>
                            <div className="d-flex align-items-center">
                                <div>
                                    {address} {glat !== null && glat > 0 && glng !== null ? <a className="ml-2 txt-link" href={`http://maps.google.com/maps?daddr=${glat},${glng}`}>مسیریابی</a> : ''}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex small-txt mt-1">
                            <div className="d-flex align-items-center mr-1">
                                <img src={Phone} width={15} alt="شماره تماس" />
                            </div>
                            <a href={`tel:${telephone}`} className="ml-2 txt-link">{telephone}</a>
                            
                        </div>
                        <div className="d-flex small-txt justify-content-end mt-1">
                            <Link to={`../shop/${id}/${title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} className="ml-2 txt-link" >جزئیات بیشتر...</Link>
                        </div>
                    </Collapse>
                </div>
                    
            </Col>

    );
}

export default CardShop;